export default __webpack_public_path__ + "static/media/ed2mit2021practice03-SQL-basics-v02.485f2ace.pdf";